import { z } from 'zod';

/**
 * フォームデータバリデーションスキーマ
 *
 * sessionStorage から復元されたデータの検証に使用
 * すべてのフィールドは optional（部分的なデータも許可）
 */
export const urlFormDataSchema = z.object({
  websiteUrl: z.string().optional(),
  companyName: z.string().optional(),
  contactName: z.string().optional(),
  email: z.string().optional(),
  message: z.string().optional(),
});

/**
 * フォームデータの型（Zod スキーマから推論）
 */
export type UrlFormDataInput = z.infer<typeof urlFormDataSchema>;

/**
 * メールアドレスバリデーションスキーマ
 *
 * Zod のビルトイン email バリデーションを使用
 * RFC 5322 に準拠した検証
 */
export const emailSchema = z
  .string()
  .min(1, { message: 'メールアドレスを入力してください' })
  .email({ message: '有効なメールアドレスを入力してください' });
